<template>
  <section id="contact" class="contact">
    <div class="container" data-aos="fade-up">
      <div class="section-title">
        <h2>Get In Touch</h2>
      </div>

      <div class="row">
        <div class="col-lg-5 d-flex align-items-stretch">
          <div class="info">
            <div class="address">
              <i class="icofont-google-map"></i>
              <h4>Address</h4>
              <p>House # 25, Road # 47, Suite # D5,
                Gulshan-02, Dhaka- 1212</p>
            </div>

            <div class="email">
              <i class="icofont-envelope"></i>
              <h4>Email</h4>
              <p>info@wintelbd.com</p>
            </div>

            <div class="phone">
              <i class="icofont-phone"></i>
              <h4>Phone</h4>
              <p>+88 02 8833463</p>
            </div>
          </div>
        </div>

        <div class="col-lg-7 mt-5 mt-lg-0 d-flex align-items-stretch">
          <form @submit.prevent="submit" class="php-email-form">
            <div class="form-row">
              <div class="form-group col-md-6">
                <label for="name">Your Name</label>
                <input
                  type="text"
                  class="form-control"
                  id="name"
                  v-model="name"
                  v-validate="'required'"
                />
                <div class="validate"></div>
              </div>
              <div class="form-group col-md-6">
                <label for="email">Email</label>
                <input
                  type="email"
                  class="form-control"
                  id="email"
                  v-model="email"
                  v-validate="'required'"
                />
                <div class="validate"></div>
              </div>
            </div>
            <div class="form-row">
              <div class="form-group col-md-6">
                <label for="mobile">Mobile</label>
                <input
                    type="text"
                    class="form-control"
                    id="mobile"
                    v-model="mobile"
                    v-validate="'required'"
                />
                <div class="validate"></div>
              </div>
              <div class="form-group col-md-6">
                <label for="company">Company</label>
                <input
                    type="text"
                    class="form-control"
                    id="company"
                    v-model="company"
                    v-validate="'required'"
                />
                <div class="validate"></div>
              </div>
            </div>
            <div class="form-row">
              <div class="form-group col-md-12">
                <label for="comments">Comments</label>
                <input
                    type="text"
                    class="form-control"
                    id="comments"
                    v-model="comments"
                    v-validate="'required'"
                />
                <div class="validate"></div>
              </div>
            </div>
            <div class="text-center">
              <button class="btn btn-primary" type="submit">Submit</button>
            </div>
          </form>
        </div>
      </div>
    </div>
  </section>
  <!-- End Contact Section -->
</template>
<script>
import axios from "axios";
export default {
  name: "About",
  data() {
    return {
      name: "",
      email: "",
      mobile: "",
      company: "",
      comments: ""
    }
  },
  methods: {
    submit(e) {
      e.preventDefault();
      this.$validator.validateAll().then((reg) => {
        if (reg) {
          let instance = this;
          axios.get(`${this.apiPath}contuct-us?name=${this.name}&email=${this.email}&mobile=${this.mobile}&company=${this.company}&comments=${this.comments}`).then(function(response){
            instance.name = "";
            instance.email = "";
            instance.password = "";
            instance.confirm = "";
            instance.$toaster.success(response.data.message);
          }.bind()).catch(function (error){
            console.log(error.response.data.message)
            instance.$toaster.error(error.response.data.message);
          });
        }
      });
    }
  }
};
</script>

<style scoped lang="scss">
</style>
